import React, { useEffect, useState } from 'react';
import { LandingPage } from './pages/LandingPage';
import { TermsPage } from './pages/TermsPage';
import { RefundPolicyPage } from './pages/RefundPolicyPage';
export function App() {
  const [currentPage, setCurrentPage] = useState(window.location.hash);
  useEffect(() => {
    const handleHashChange = () => {
      setCurrentPage(window.location.hash);
    };
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);
  if (currentPage === '#terms') return <TermsPage data-id="element-0" />;
  if (currentPage === '#refund-policy') return <RefundPolicyPage data-id="element-1" />;
  return <LandingPage data-id="element-2" />;
}